import React, { useEffect } from 'react'
import { NavLink } from 'react-router-dom'
import { MdLocalShipping, MdAddShoppingCart, MdEdit, MdEventBusy } from 'react-icons/md'
import '@/styles/components/mobile-action-bar.css'

/**
 * Fixed bottom bar for phones: the handful of things a customer does most,
 * always in reach from any page.
 *
 * Each tile navigates to a page (My Deliveries, Products, Delivery Management,
 * Pause deliveries) and highlights when that page is the current one. Pause is
 * a full-page route here rather than the dialog the desktop rail opens.
 *
 * Rendered once, globally (see App), and shown only at phone widths via CSS.
 * Desktop keeps the action tiles in the My Deliveries rail instead.
 */
function MobileActionBar(): React.JSX.Element {
  // Reserve space at the foot of every page so content and the footer clear
  // the fixed bar.
  useEffect(() => {
    document.body.classList.add('has-mobile-action-bar')
    return () => document.body.classList.remove('has-mobile-action-bar')
  }, [])

  const itemClass = ({ isActive }: { isActive: boolean }): string =>
    `mab-item${isActive ? ' is-active' : ''}`

  return (
    <nav className="mobile-action-bar" aria-label="Quick actions">
      <NavLink to="/" end className={itemClass}>
        <MdLocalShipping aria-hidden="true" />
        <span>My Deliveries</span>
      </NavLink>

      <NavLink to="/products" className={itemClass}>
        <MdAddShoppingCart aria-hidden="true" />
        <span>Add a product</span>
      </NavLink>

      <NavLink to="/delivery-management" className={itemClass}>
        <MdEdit aria-hidden="true" />
        <span>Manage my Delivery</span>
      </NavLink>

      <NavLink to="/pause-deliveries" className={itemClass}>
        <MdEventBusy aria-hidden="true" />
        <span>Pause delivery</span>
      </NavLink>
    </nav>
  )
}

export default MobileActionBar
